import { store } from "@store";
import * as actionTypes from "./actionTypes";
import { actions as returnOrderActions } from "@reducers/returnOrdersReducer";

export const actions = {
  fetchReturnOrderListRequest: (payload = {}) => ({
    type: actionTypes.FETCH_RETURN_ORDERS_LIST_REQUEST,
    payload,
  }),
  fetchMoreReturnOrdersRequest: (payload = {}) => ({
    type: actionTypes.FETCH_MORE_RETURN_ORDERS_LIST_REQUEST,
    payload,
  }),
  fetchReturnOrderListSuccess: (payload) => ({
    type: actionTypes.FETCH_RETURN_ORDERS_LIST_SUCCESS,
    payload,
  }),
  cancelReturnRequest: (payload) => ({
    type: actionTypes.CANCEL_RETURN_REQUEST,
    payload,
  }),
  pickupRVPScheduleReq: (payload) => ({
    type: actionTypes.RVP_PICKUP_DATE,
    payload,
  }),
};

const initialState = {
  allReturnOrders: [],
  loading: false,
  totalCount: null,
  modalValues: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_RETURN_ORDERS_LIST_REQUEST: {
      return {
        ...state,
        loading: true,
        modalValues: null,
      };
    }

    case actionTypes.FETCH_RETURN_ORDERS_LIST_SUCCESS:
      return {
        ...state,
        allReturnOrders: action.returnOrders.data,
        loading: false,
        totalCount: action.returnOrders.count,
      };

    case actionTypes.FETCH__MORE_RETURN_ORDERS_LIST_SUCCESS:
      return {
        ...state,
        allReturnOrders: state.allReturnOrders.concat(action.returnOrders.data),
        loading: false,
      };

    case actionTypes.SET_MODAL_VALUES:
      return {
        ...state,
        modalValues: {
          heading: action.payload?.heading,
          message: action.payload?.message,
          buttons: action.payload?.buttons,
          onPress: () =>
            store.dispatch(returnOrderActions.fetchReturnOrderListRequest()),
        },
      };
  }
  return state;
};
reducer.initialState = initialState;
export default reducer;
